import Toast, {
	ToastBody,
	ToastBold,
	ToastHeader,
} from '@/components/shared/Toast'
import truncateString from '@/utils/formatting/truncateString'

type Props = {
	email?: string
	error?: boolean
	translations?: { [key: string]: string }
}

type ToastBodyProps = {
	email?: string
	error?: boolean
	message: string
}

const CopytoAccountToastBody = ({
	error,
	email,
	message,
}: ToastBodyProps): JSX.Element => {
	if (error) {
		return <>{message}</>
	}

	const truncatedEmail = truncateString(email)
	const serialisedMessage = message?.replace(/\[(.*?)\]/g, '')

	return (
		<>
			{serialisedMessage}
			<ToastBold>{truncatedEmail}</ToastBold>
		</>
	)
}

export default function CopyToAccountToast({
	email,
	error = false,
	translations,
}: Props): JSX.Element {
	const { heading, message } = translations

	return (
		<Toast>
			<ToastBody data-testid="copy-to-account-toast-message">
				<ToastHeader heading={heading} />
				<CopytoAccountToastBody email={email} error={error} message={message} />
			</ToastBody>
		</Toast>
	)
}
